<template>
  <div
    class="link-btn"
    :style="{
      height: computedHeight,
    }"
  >
    <div class="link-btn__head text-blue text-left">
      <slot name="head">
        <span>{{ text }}</span>
      </slot>
    </div>
    <div class="link-btn__tail">
      <slot name="tail">
        <div class="i-arrow-blue"></div>
      </slot>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/runtime-core";
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
    height: {
      type: [String, Number],
      default: "auto",
    },
  },
  setup(props) {
    const computedHeight = computed(() =>
      /^\d+$/.test(props.height) ? `${props.height}px` : props.height
    );
    return {
      computedHeight,
    };
  },
};
</script>

<style lang="scss" scoped>
.link-btn {
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;

  &__head {
    padding-right: 10px;
  }
}
</style>
